import { atom } from "recoil";

export const isAutoMitigateInProgressState = atom<boolean>({
  key: "isAutoMitigateInProgressState",
  default: false,
});
